module.exports = __webpack_public_path__ + "img/background-1.3499ae23.png";